<div class="projects">
  @for (project of projects; track $index) {
    <div class="project__element {{project.layoutClass}}" (click)="onImageClicked(project)">

      <div class="project__element-content">
        @for (projectElementImage of project.images; track $index) {
         <picture class="project__img">
            <source [srcset]="projectElementImage" type="image/webp" class="project__img">
            <img [src]="projectElementImage" alt="{{ project.title }} image">
          </picture>
          <div class="project__element-hover">
            <div class="project__element-text">{{ project.title }}</div>
          </div>
        }
      </div>
      <div class="project__visualization-container">
        <picture class="project__visualization">
          <source [srcset]="project.visualisation" type="image/webp" class="project__visualization">
          <img [src]="project.visualisation" alt="{{ project.title }} image" class="project__visualization">
        </picture>
      </div>

    </div>
  }
</div>

@if (isModalVisible) {
  <app-image-modal [work]="selectedProject" (close)="closeModal()"></app-image-modal>
}
